export const SOURCES_STORE_KEY = 'sources';
export const SOURCES_SERVICE_KEY = 'sources';
export const SOURCES_API_URL = '/api/v1/source/';
export const EXTERNAL_OAUTH_URL = '/api/v1/external_oauth/';
